import React, { useState, useEffect } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { connectMetamask, signRequest } from '../../utils/web3'
import { beforeWallet, setWalletAddress } from '../wallet/wallet.action';
import { login, signup } from '../user/user.action';
import validator from 'validator';

const Wallet = (props) => {
    const [connectedAddress, setConnectedAddress] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [showSignUp, setShowSignUp] = useState(false);
    const [showSignUpComponent, setShowSignUpComponent] = useState(false);
    const [email, setEmail] = useState('');
    const [username, setUsername] = useState('');
    const [valuesValidation, setValuesValidation] = useState(false);

    const [submitCheck, setSubmitCheck] = useState(false)
    const history = useHistory();

    const [msg, setMsg] = useState({
        email: '',
        username: '',
        status: ''
    })

    const connectMetamaskCall = async () => {
        let connectedAddress = await connectMetamask();
        setConnectedAddress(connectedAddress);
        setWalletAddress(connectedAddress);
    }

    useEffect(() => {
        if (localStorage.getItem('encuse')) {
            history.push('/profile')
        }
    }, [])

    useEffect(() => {
        if (props.error) {
            setErrorMessage(props.error.message);
            if (props.error.notExist) {
                setShowSignUp(true);
            } else {
                setShowSignUp(false);
            }
        }
    }, [props.error]);

    const signup = async (e) => {
        e.preventDefault();
        setSubmitCheck(true)
        if (validator.isEmail(email) && !validator.isEmpty(username)
            && (valuesValidation)) {

            let sign = await signRequest();
            let payload = {
                address: connectedAddress,
                password: sign,
                email: email,
                username: username
            }
            props.signup(payload);
        }
        else {
            let data = {
                email: '',
                username: '',
                status: ''
            }
            if (!validator.isEmail(email)) {
                data.email = 'Email Is Required.'
            }
            if (validator.isEmpty(username)) {
                data.username = 'Username Is Required.'
            }
            if (!(valuesValidation)) {
                data.status = 'Agree To Privacy Policy Is Required.'
            }
            setMsg(data)
        }

    }

    const login = async () => {
        let sign = await signRequest();
        let payload = {
            address: connectedAddress,
            password: sign
        }
        props.login(payload);
    }

    const switchSignup = () => {
        setShowSignUpComponent(true);
    }

    if (props.user.userAuth) {
        return <Redirect to="/profile" />
    }

    return (
        <section className={!showSignUpComponent ? `wallet-connect-area` : `author-area`}>
            {
                localStorage.getItem('encuse') ? '' :
                    <div className="container">
                        {
                            connectedAddress && !showSignUpComponent ?
                                <>
                                    <div className="row justify-content-center">
                                        <div className="col-12 col-md-8 col-lg-7">
                                            {/* Intro */}
                                            <div className="intro text-center">
                                                {/* <span>Sign In</span> */}
                                                <h3 className="mt-3 mb-0">Sign in to your account</h3>
                                                {/* <p>Please select the wallet you want to connect to.</p> */}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row justify-content-center items">
                                        <div className="col-12 col-md-6 item">
                                            <div className="card single-wallet">
                                                <span className="d-block text-center" href="/login">
                                                    <h4 className="mb-0">Address</h4>
                                                    <p id="connected-address">{connectedAddress}</p>
                                                    {
                                                        errorMessage && <p className="text-white">{errorMessage}</p>
                                                    }
                                                    <button className="btn w-100 mt-3 mt-sm-4" type="button" onClick={() => login()}>Sign In</button>
                                                    {
                                                        showSignUp && <button className="btn w-100 mt-3 mt-sm-4" type="button" onClick={() => switchSignup()}>Would you like to Signup?</button>
                                                    }
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </>
                                :
                                showSignUpComponent ?
                                    <div className="row justify-content-center">
                                        <div className="col-12 col-md-8 col-lg-7">
                                            {/* Intro */}
                                            <div className="intro text-center">
                                                {/* <span>SIGNUP</span> */}
                                                <h3 className="mt-3 mb-0">Create an Account</h3>
                                                <p>Create the account with the address</p>
                                            </div>
                                            {/* Item Form */}
                                            <form className="item-form card no-hover" onSubmit={(e) => signup(e)}>
                                                <div className="row">
                                                    {
                                                        errorMessage && <p className="text-white">{errorMessage}</p>
                                                    }
                                                    <div className="col-12">
                                                        <div className="form-group mt-3">
                                                            <input type="text" className="form-control" name="address" placeholder="Address" disabled={true} value={connectedAddress} />
                                                        </div>
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="form-group mt-3">
                                                            <input type="text" className="form-control" name="email" placeholder="Enter your Email" defaultValue={email}
                                                                onChange={(e) => {
                                                                    setEmail(e.target.value);
                                                                    if (submitCheck) {
                                                                        if (e.target.value) {
                                                                            setMsg({ ...msg, email: '' })
                                                                        }
                                                                        else {
                                                                            setMsg({ ...msg, email: 'Email Is Invalid.' })
                                                                        }
                                                                    }
                                                                }}
                                                            />
                                                            <label className={`text-danger pl-1 ${msg.email ? `` : `d-none`}`}>{msg.email}</label>
                                                        </div>
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="form-group mt-3">
                                                            <input type="text" className="form-control" name="username" placeholder="Enter your Username" defaultValue={username}
                                                                onChange={(e) => {
                                                                    setUsername(e.target.value);
                                                                    if (submitCheck) {
                                                                        if (e.target.value) {
                                                                            setMsg({ ...msg, username: '' })
                                                                        }
                                                                        else {
                                                                            setMsg({ ...msg, username: 'Username Is Required.' })
                                                                        }
                                                                    }
                                                                }}
                                                            />
                                                            <label className={`text-danger pl-1 ${msg.username ? `` : `d-none`}`}>{msg.username}</label>
                                                        </div>
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="form-group mt-3">
                                                            <div className="form-check form-check-inline">
                                                                <input className="form-check-input" type="checkbox" name="inlineRadioOptions" id="inlineRadio1" defaultValue="policy-checkbox"
                                                                    onChange={(e) => {
                                                                        setValuesValidation(e.target.checked);
                                                                        if (submitCheck) {
                                                                            if (e.target.checked) {
                                                                                setMsg({ ...msg, status: '' })
                                                                            }
                                                                            else {
                                                                                setMsg({ ...msg, status: 'Agree To Privacy Policy Is Required.' })
                                                                            }
                                                                        }
                                                                    }}
                                                                />
                                                                <label className="form-check-label" htmlFor="inlineRadio1">I agree to <a href="/privacy-and-terms">Privacy Policy</a></label>
                                                            </div>
                                                            <label className={`text-danger pl-1 ${msg.status ? `` : `d-none`}`}>{msg.status}</label>
                                                        </div>
                                                    </div>
                                                    <div className="col-12">
                                                        <button className="btn w-100 mt-3 mt-sm-4" type="submit">Sign Up</button>
                                                    </div>
                                                    {/* <div className="col-12">
                                        <span className="d-block text-center mt-4">Already have an account? <a href="/login">Login</a></span>
                                    </div> */}
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                    :
                                    <>
                                        <div className="row justify-content-center">
                                            <div className="col-12 col-md-8 col-lg-7">
                                                {/* Intro */}
                                                <div className="intro text-center">
                                                    {/* <span>Wallet Connect</span> */}
                                                    <h3 className="mt-3 mb-0">Connect your Wallet</h3>
                                                    <p>Please select the wallet you want to connect to.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row justify-content-center items">
                                            <div className="col-12 col-md-6 item" onClick={() => connectMetamaskCall()}>
                                                {
                                                    errorMessage && <p className="text-white">{errorMessage}</p>
                                                }
                                                {/* Single Wallet */}
                                                <div className="card single-wallet whole-hover">
                                                    <span className="d-block text-center" href="/login">
                                                        <img className="avatar-lg" src="/img/metamask2.png" alt="" />
                                                        <h4 className="mb-0">MetaMask</h4>
                                                        <p>A browser extension with great flexibility. The web's most popular wallet</p>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                        }
                    </div>
            }
        </section>
    );
}

const mapStateToProps = state => ({
    wallet: state.wallet,
    user: state.user,
    error: state.error
});

export default connect(mapStateToProps, { beforeWallet, setWalletAddress, login, signup })(Wallet);